/**
 * Returns a cryptographically secure random integer in [0, maxExclusive).
 * Uses rejection sampling to avoid modulo bias.
 */
export function secureRandomInt(maxExclusive: number): number {
  if (maxExclusive <= 0) {
    return 0;
  }

  const maxUint32 = 0x100000000;
  const limit = Math.floor(maxUint32 / maxExclusive) * maxExclusive;
  const buf = new Uint32Array(1);

  do {
    crypto.getRandomValues(buf);
  } while (buf[0] >= limit);

  return buf[0] % maxExclusive;
}

/**
 * Returns a new array with elements shuffled in cryptographically random order
 * (Fisher-Yates using secureRandomInt).
 */
export function secureShuffle<T>(items: T[]): T[] {
  const shuffled = [...items];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = secureRandomInt(i + 1);
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
